export const DEFAULT_CAMPAIGN_COLOR = '#ffffff';

export const CAMPAIGN_RULES_TYPES = {
  origin: 11,
  vehicleEngine: 13,
  skus: 15,
  vehicles: 16,
  prices: 17,
  bookingContractTypeIsRule: 20,
  bookingContractPeriodIsRule: 21,
  campaignHasCoupons: 22,
  empty: 2,
};

export const CAMPAIGN_MONTHLY_PRICE_DURATIONS = [
  { text: 'Contract Period', value: 0 },
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
];
